
// #region Imports
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import {
  type MRT_Row,
} from "material-react-table";
import { FeeScheduleTemplateLoadIssue, isFeeScheduleTemplateLoadIssue } from "work/fee-schedule-templates/_store/fee-schedule-templates-redux-slice";
import { PageTab } from "work/fee-schedule-templates/_views/pages/tabs";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";
import Guid from "_shared/guids/guid";
// #endregion

// #region Styled Components
const RowActionsContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "nowrap",
  width: "inherit",
}));
// #endregion

// #region Props
type FeeScheduleToolbarProps = {
  row: MRT_Row<FeeScheduleTemplate | FeeScheduleTemplateLoadIssue>;
  activeTab: PageTab;
  onArchivedChange: (id: Guid, archived: boolean) => void;
  onDelete: (id: Guid) => void;
};

export default function FeeScheduleToolbar(props: Readonly<FeeScheduleToolbarProps>) {
  const { row, activeTab, onArchivedChange, onDelete } = props;

  if (isFeeScheduleTemplateLoadIssue(row.original)) return null;

  // #region Render
  return (
    <RowActionsContainer>
      {activeTab === PageTab.Templates && (
        <Tooltip title="Delete Template">
          <span>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                if (!row.original.id) {
                  console.warn("Attempting to delete a fee schedule template with no id");
                  return;
                }
                onDelete(row.original.id);
              }}
            >
              <DeleteIcon color="error" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {activeTab !== PageTab.Active && (
        <Tooltip title={row.original.archived ? "Un-Archive Template" : "Archive Template"}>
          <span>
            <IconButton
              onClick={(event) => {
                if (isFeeScheduleTemplateLoadIssue(row.original)) return;
                event.stopPropagation();
                if (!row.original.id) {
                  console.warn("Attempting to archive/unarchive a fee schedule template with no id");
                  return;
                }
                onArchivedChange(row.original.id, !row.original.archived);
              }}
            >
              {row.original.archived ? <UnarchiveIcon /> : <ArchiveIcon />}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </RowActionsContainer>
  );
}
